import {
  type shopGridView,
  useUserStore,
} from '@frontend/libs/stores/useUserStore'
import { Button, ButtonGroup } from '@nextui-org/react'

import GridFour from '../../../components/icons/outline/GridFour'
import GridThree from '../../../components/icons/outline/GridThree'

export interface ShopSwitchViewProps {
  onChange: (value: shopGridView) => void
}

export function ShopSwitchView({ onChange }: Readonly<ShopSwitchViewProps>) {
  const { shopGridView } = useUserStore((state) => state)

  return (
    <ButtonGroup className="gap-1">
      <Button
        className="overflow-visible"
        isIconOnly
        onPress={() => onChange('three-col')}
        size="sm"
        variant="light"
      >
        <GridThree className="h-10 w-10" />
        {shopGridView === 'three-col' && (
          <span className="absolute -bottom-[0.4rem] block h-[2px] w-full bg-primary"></span>
        )}
      </Button>
      <Button
        className="overflow-visible"
        isIconOnly
        onPress={() => onChange('four-col')}
        size="sm"
        variant="light"
      >
        <GridFour className="h-10 w-10" />
        {shopGridView === 'four-col' && (
          <span className="absolute -bottom-[0.4rem] block h-[2px] w-full bg-primary"></span>
        )}
      </Button>
    </ButtonGroup>
  )
}

export default ShopSwitchView
